<template>
  <button :class="{ dense, accent }" :disabled="busy">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "cms-button",
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    accent: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped>
button {
  border: 0;
  margin: 0;
  font-size: 0.9rem;
  white-space: nowrap;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
  padding: 10px 18px;
  min-width: 80px;
  outline: transparent;
  color: #fff;
  background-color: var(--crf-primary);
}

button.dense {
  padding: 7px 10px;
}

button:not([disabled]):hover {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  filter: brightness(130%);
}

:where(.dark) button {
  background-color: #10111b;
  background-color: #ffffff;
  color: #000;
}

button.accent {
  color: #fff;
  background-color: var(--crf-accent);
}

button:not([disabled]).accent:hover {
  filter: brightness(110%);
}

button[disabled] {
  cursor: default;
  background-color: #CBCCCD;
}
</style>
